import { Component } from '@angular/core';
import { IonicPage, MenuController,  NavController, NavParams } from 'ionic-angular';
import { CoolLocalStorage } from 'angular2-cool-storage';
import {AngularFireDatabase,  FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import {AngularFireAuth} from 'angularfire2/auth';
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-score',
  templateUrl: 'score.html',
})
export class ScorePage {

  live: FirebaseObjectObservable<any[]>;
  game: FirebaseObjectObservable<any[]>;
  board: FirebaseListObservable<any[]>;
  localStorage: CoolLocalStorage;
  answered : Boolean = false;
  count: number = 0;
  myscore: number;
  scorer: FirebaseObjectObservable<any[]>;
  users: FirebaseListObservable<any[]>;
  settings: any;
  record: FirebaseListObservable<any[]>;
  show:Boolean = false;
  me: any;


  constructor( menuCtrl: MenuController, localStorage: CoolLocalStorage, public navCtrl: NavController, public navParams: NavParams, private afauth: AngularFireAuth, private db: AngularFireDatabase) {

    const authObserver = afauth.authState.subscribe( user => {
      if (user == null) {
        this.navCtrl.setRoot(LoginPage);
        authObserver.unsubscribe();
      }
      else
      {
          this.me = user.uid;
          menuCtrl.enable(false);
          this.localStorage = localStorage;
          this.game  = db.object('/v2/game/' + this.localStorage.getItem('code'));
          this.scorer = db.object('/v2/users/' + this.localStorage.getItem('code') + '/' + this.afauth.auth.currentUser.uid + "/score");
          this.record = db.list('/v2/record/' + this.localStorage.getItem('code') + '/' + this.afauth.auth.currentUser.uid );
          this.users = db.list('/v2/users/' + this.localStorage.getItem('code'));

          db.object('/v2/game/' + this.localStorage.getItem('code') + "/show")
          .subscribe(data => {

               this.show = data.$value;


          })

          this.game.subscribe(data =>
          {
              this.settings = data;
              console.log(this.settings);
          })


          db.object('/v2/game/' + this.localStorage.getItem('code') + '/one/live')
          .subscribe(data =>
            {
              this.live = data;
              this.answered = false;

            });


          this.board  = db.list('/v2/scoreboard/' + this.localStorage.getItem('code'));
          this.board.subscribe(result => {
              this.count = result.length;
          });

          db.object('/v2/users/' + this.localStorage.getItem('code') + '/' + this.afauth.auth.currentUser.uid + "/score" )
          .subscribe(data =>
            {

              this.myscore = parseInt(data.$value);

            });
          }})

  }




   signOut()
   {
      this.afauth.auth.signOut();
      this.navCtrl.setRoot(LoginPage);
   }
  score(ans, correct)
  {
      this.answered = true;

      this.record.push({correct: correct, answer: ans})

      if(ans == correct)
      {

        if(this.count == 0)
        {
           this.scorer.set(this.myscore + parseInt(this.settings.score) + parseInt(this.settings.first))
        }

        if(this.count == 1)
        {
           this.scorer.set(this.myscore + parseInt(this.settings.score) + parseInt(this.settings.second))
        }

        if(this.count == 2)
        {
           this.scorer.set(this.myscore + parseInt(this.settings.score) + parseInt(this.settings.third))
        }

        if(this.count > 3)
        {
           this.scorer.set(this.myscore + parseInt(this.settings.score))
        }





        if(this.count < 3)
        {
          this.board.push("here");
        }



      }


  }

}



// WEBPACK FOOTER //
// ./src/pages/score/score.ts